import React from "react";
import styles from "./Service.module.css";
import { Container, Row, Col } from "react-bootstrap";
import g1 from "../../assets/service/1.png";
import g2 from "../../assets/service/2.png";
import g3 from "../../assets/service/3.png";
import g4 from "../../assets/service/pcb.png";
import g5 from "../../assets/service/5.png";
import ServiceCard from "./ServiceCard/ServiceCard";
const Service = () => {
  return (
    <div>
      <Container>
        <div className="top_line"></div>
        <div className="section_heading pb-4">Our Services</div>
        <Row>
          <ServiceCard
            img={g1}
            title="3D Printing"
            desc={
              "Fused Deposition Modeling. FDM 3D printing is the most used, available and affordable 3D printing technology. It has a resolution of 0.1mm-1mm layer height which is very suitable for rapid and low cost prototyping. ."
            }
            link="/services/3D-Printing"
          />
          <ServiceCard
            img={g2}
            title="Laser Cutting"
            desc={
              "Our high power CO2 laser cutter machine can cut or engrave on any plastic, paper, wooden or organic material like leather, clothes etc easily upto 8mm thickness (depends on material)."
            }
            link="/services/Laser-Cutting"
          />
          <ServiceCard
            img={g3}
            title="Silicon Molding"
            desc={
              "Silicone molding is is simple and accurate and will forgive many mistakes. The idea is to start with a master part. This part can be encapsulated with molding material and then many parts can be made from the resulting negative.This master ......"
            }
            link="/services/Silicon-Molding"
          />
          <ServiceCard
            img={g4}
            title="PCB"
            desc={
              "We manufacture quality Printed Circuit Boards in both mass quantity and low quantity."
            }
            link="/services/PCB-Manufacturing"
          />
          <ServiceCard
            img={g5}
            title="Product Development"
            desc={
              "We provide product development and RnD support with prototyping and mass production. We have a team of well skilled engineers for RnD in mechanical, electronics and software programming sections"
            }
            link="/services/Product-Development"
          />
        </Row>
      </Container>
    </div>
  );
};

export default Service;
